import React, { useState } from "react";

const WA_URL = "https://wa.me/573152426950";

export default function Chat() {
  const [hovered, setHovered] = useState(false);

  return (
    <a
      href={WA_URL}
      target="_blank"
      rel="noopener noreferrer"
      title="Chatear por WhatsApp"
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        position: "fixed",
        bottom: 24,
        right: 24,
        zIndex: 9999,
        width: 56,
        height: 56,
        borderRadius: "50%",
        background: hovered ? "#1ebe57" : "#25D366",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: "0 4px 16px rgba(0,0,0,0.35)",
        textDecoration: "none",
        transition: "background 0.2s, transform 0.2s",
        transform: hovered ? "scale(1.1)" : "scale(1)",
      }}
    >
      <i className="bi bi-whatsapp" style={{ fontSize: 28, color: "#fff" }}></i>
    </a>
  );
}
